import { PageActionRenderer } from 'app/components/BasicTable/PageActions/PageActionsRenderer';
import { AddSuperGroup } from './AddSuperGroup';

interface GetPageActionsProps {
  isAdmin: boolean;
}

export function GePageActions(
  props: GetPageActionsProps,
): PageActionRenderer[] {
  const PageActions = props.isAdmin
    ? [(dataCount, refresh) => <AddSuperGroup />]
    : [];
  return PageActions;
}
